import React from 'react';
import { Box, FormControlLabel, Radio, Typography } from '@mui/material';
import { PinnacleTextField } from '../../../../../../components/PinnacleTextField';
import { E_FIELD_REQUIRED } from '../../../../../../utils/constants';
import { ExamByCodeFormData } from '../../../../hooks/useExamByCodeForm';

interface AnswersKeyFormProps {
    touchedFields: Record<keyof ExamByCodeFormData, boolean>;
    onBlur: (field: keyof ExamByCodeFormData) => void;
    isSubmitting: boolean;
    formData: ExamByCodeFormData;
    onChange: (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
}

const AnswersKeyForm: React.FC<AnswersKeyFormProps> = ({
    touchedFields,
    onBlur,
    isSubmitting,
    formData,
    onChange
}) => {
    const handleSelectAnswer = (
        questionNumber: number,
        value: 'a' | 'b' | 'c' | 'd' | 'bonus'
    ) => {
        const updated = [...(formData.answerKey || [])];
        updated[questionNumber - 1] = value.toUpperCase();

        onChange({
            target: {
                name: 'answerKey',
                value: updated,
            },
        } as any);
    };

    const totalItems = Number(formData.numberOfQuestions) || 0;
    return (
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2.5 }}>
            <PinnacleTextField
                label="No. of Items"
                type="number"
                name="numberOfQuestions"
                value={formData.numberOfQuestions}
                onChange={onChange}
                fullWidth
                onBlur={() => onBlur('numberOfQuestions')}
                error={touchedFields.numberOfQuestions && !Number.isInteger(formData.numberOfQuestions) && formData.numberOfQuestions === 0}
                helperText={
                    touchedFields.numberOfQuestions && !Number.isInteger(formData.numberOfQuestions) && formData.numberOfQuestions === 0
                        ? E_FIELD_REQUIRED
                        : ' '
                }
                disabled={isSubmitting}
                slotProps={{
                    htmlInput: {
                        min: 0,
                    },
                }}
            />

            {totalItems > 0 && (
                <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                    {Array.from({ length: totalItems }).map((_, index) => {
                        const questionNo = index + 1;
                        const selected = formData.answerKey?.[questionNo - 1];

                        return (
                            <Box
                                key={questionNo}
                                sx={{
                                    display: "grid",
                                    gridTemplateColumns: "40px repeat(5, auto)",
                                    alignItems: "center",
                                    gap: 2,
                                }}
                            >
                                <Typography fontWeight={500}>
                                    {questionNo}.
                                </Typography>

                                {(['a', 'b', 'c', 'd', 'bonus'] as const).map(option => (
                                    <FormControlLabel
                                        key={option}
                                        label={option}
                                        control={
                                            <Radio
                                                checked={selected === option.toUpperCase()}
                                                onChange={() =>
                                                    handleSelectAnswer(questionNo, option)
                                                }
                                            />
                                        }
                                    />
                                ))}
                            </Box>
                        );
                    })}
                </Box>
            )}
        </Box>
    );
};


export default AnswersKeyForm;
